import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import ImmutablePropTypes from 'react-immutable-proptypes';

import Modal from 'components/Modal/Modal';
import SlideInFromTheSideModal from 'components/Modal/SlideInFromTheSideModal';

import { toggleModal } from 'actions/modalActions';

import './ModalLayout.desktop.scss';

/* istanbul ignore next */
const mapStateToProps = state => ({
  appState: state.appState,
});

function mapDispatchToProps(dispatch) {
  return {
    toggleModalBound: () => dispatch(toggleModal('')),
  };
}

export class ModalLayout extends Component {
  static propTypes = {
    appState: ImmutablePropTypes.map.isRequired,
    children: PropTypes.object.isRequired,
    icon: PropTypes.string,
    modalConfig: PropTypes.object,
    toggleModalBound: PropTypes.func.isRequired,
  };

  render() {
    const {
      appState,
      children,
      icon,
      modalConfig,
      toggleModalBound,
    } = this.props;

    let ModalComponent = Modal;
    if (modalConfig && modalConfig.slideInFromTheSide) {
      ModalComponent = SlideInFromTheSideModal;
    }

    return (
      <div className="modal-layout">
        { (!modalConfig || !modalConfig.isStandaloneModal) &&
          <ModalComponent
            icon={icon}
            onModalClose={toggleModalBound}
            modalConfig={modalConfig}
            isMobileBreakpoint={appState.get('isMobileBreakpoint')}
          >
            {children}
          </ModalComponent>
        }
        { !!modalConfig && modalConfig.isStandaloneModal && (<div className="modal-layout__standalone">{ children }</div>) }
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalLayout);



/** WEBPACK FOOTER **
 ** ./src/layouts/ModalLayout/ModalLayout.jsx
 **/